export const ElementQuery = {
  all: '全て',
  exic: 'EX-ICのみ',
  business_ekinet_proxy: 'ビジえき代理手配のみ',
  air_seat_number_empty: '座席が空欄'
} as const;

export type ElementQueryKey = keyof typeof ElementQuery;

export const ElementQueryKeys: readonly ElementQueryKey[] = [
  'all',
  'exic',
  'business_ekinet_proxy',
  'air_seat_number_empty'
];
